/**
 * Configuration — single company-wide settings page.
 * Merges Team Members, Company, and Projects into tabs instead of three
 * separate pages under a "Manage" nav group.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Users2, Building2, Folder } from 'lucide-react';
import TeamMembers from './TeamMembers';
import CompanySettings from './CompanySettings';
import ProjectSettings from '../projects/ProjectSettings';
import { useT } from '@/lib/LanguageContext';

export default function Configuration({ initialTab = 'team' }) {
  const t = useT();
  const navigate = useNavigate();

  return (
    <Layout title={t('nav.configuration')}>
      <div className="container mx-auto p-8 max-w-5xl">
        <Tabs
          defaultValue={initialTab}
          onValueChange={(v) => navigate(`/settings/${v}`, { replace: true })}
        >
          <TabsList className="mb-6">
            <TabsTrigger value="team" className="gap-1.5">
              <Users2 className="w-4 h-4" /> {t('nav.team_members')}
            </TabsTrigger>
            <TabsTrigger value="company" className="gap-1.5">
              <Building2 className="w-4 h-4" /> {t('nav.company')}
            </TabsTrigger>
            <TabsTrigger value="projects" className="gap-1.5">
              <Folder className="w-4 h-4" /> {t('nav.projects')}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="team">
            <TeamMembers embedded />
          </TabsContent>
          <TabsContent value="company">
            <CompanySettings embedded />
          </TabsContent>
          <TabsContent value="projects">
            <ProjectSettings embedded />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
